import {Component} from "react";
import {AppPageWrapper} from "../NavMenu/AppPageWrapper";
import {Spinner} from "react-bootstrap";
import InvalidPasswordReset from "./InvalidPasswordReset";
import RequestPhonePin from "./RequestPhonePin";
import EnterPhonePin from "./EnterPhonePin";
import NewPassword from "./PasswordInputs/NewPassword";
import {Home} from "../../config/Routes";
import {Redirect} from "react-router-dom";
import {UpdateUserPassword} from "../../api/Secuirty/UpdateUserPassword";
import {toast} from "react-toastify";

function addDays(date: Date, days: number) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export interface PasswordResetRouteLandingRoute{
    linkId?: string
    linkTime?: string
    userName?: string
}
interface PasswordResetRouteLandingState{
    requestedPhonePinSend: boolean
    pin: string
    showPassword: boolean
    changingPassword: boolean
    goHome: boolean
}
export default class PasswordResetLanding extends Component<PasswordResetRouteLandingRoute, PasswordResetRouteLandingState> {

    state: PasswordResetRouteLandingState = {
        requestedPhonePinSend: false,
        pin: '',
        showPassword: false,
        changingPassword: false,
        goHome: false,
    }

    isPasswordTimeInvalid = (): boolean => {
        const linkTime = parseInt(this.props.linkTime || '');
        if(!this.props.linkTime || isNaN(linkTime)){
            return true;
        }
        const linkCreatedEpochTimeMS = linkTime * 1000;
        const currentDate = new Date(Date.now());
        const expireDate = addDays(new Date(linkCreatedEpochTimeMS), 1);
        const timeBetweenDate = expireDate.getUTCMilliseconds() - currentDate.getUTCMilliseconds();
        return timeBetweenDate < 1;
    }

    pinRequested = (): void => {
        this.setState({requestedPhonePinSend: true})
    }

    pinChanged = (pin: string): void => {
        this.setState({pin})
    }

    pinSubmitted = (): void => {
        this.setState({showPassword: true});
    }

    requestPasswordChange = (newPassword: string): void => {
        const reportError = () => {
            toast.error("Unknown Error Updating Password! Password May Have Been To Similar!")
            this.setState({changingPassword: false, showPassword: true});
        }
        const passwordChanged = () => {
            toast.success("Password Changed!")
            this.setState({goHome: true});
        }
        UpdateUserPassword(this.props.userName || '', this.props.linkId || '', this.state.pin, newPassword, '', reportError).then(passwordChanged);
        this.setState({changingPassword: true});
    }

    render() {
        const validLinkTime = this.isPasswordTimeInvalid();
        return<AppPageWrapper showNav={false}>
            <div className="m-2">
                {this.state.goHome && <Redirect to={Home} /> }
                {!validLinkTime &&
                    <InvalidPasswordReset />
                }
                {!this.state.changingPassword && validLinkTime && !this.state.requestedPhonePinSend &&
                    <RequestPhonePin userName={this.props.userName} requestedPhone={this.pinRequested}/>
                }
                {!this.state.changingPassword && validLinkTime && !this.state.showPassword && this.state.requestedPhonePinSend  &&
                    <EnterPhonePin pin={this.state.pin}
                                   userName={this.props.userName}
                                   changePin={(e) => {this.pinChanged(e)}}
                                   submitPin={()=>{this.pinSubmitted()}}  />
                }
                {!this.state.changingPassword && validLinkTime && this.state.showPassword &&
                    <NewPassword submitPassword={(password)=>{this.requestPasswordChange(password)}}/>
                }
                {validLinkTime && this.state.changingPassword && <>
                    <Spinner animation="border"/>
                    <br/>
                    Updating Password..
                </>}
            </div>
            </AppPageWrapper>
    }
}
